<div class="bmc-topbar bz-space--stack-l">
  <div class="bmc-topbar__header">
    <bzg-icon class="bz-space--inline-m bmc-topbar__back"
              [nameIcon]="'icon-arrow-left-bold'"
              [size]="16"
              (click)="closePackageVisualizerDetail()">
    </bzg-icon>
    <div class="bmc-topbar__info">
      <h4 class="bmc-topbar__bex-name" *ngIf="!isSearchMode">
        {{packageName}}
      </h4>
      <h4 class="bmc-topbar__title-text" *ngIf="!isSearchMode">
        {{ displayName || ('PACKAGE_VISUALIZER.DISPLAY_NAME' | translate) }}
      </h4>
    </div>
  </div>

  <bzg-icon class="bz-space--inline-s bmc-topbar__close-search" [nameIcon]="'icon-close-strong'"
    (click)="endSearchMode()" *ngIf="isSearchMode && showSearch" [color]="'active'">
  </bzg-icon>
  <div class="bmc-topbar__right-container" *ngIf="showSearch"
    [ngClass]="{'bmc-topbar--search-mode': isSearchMode}">
    <div class="bmc-topbar__input-field"
      [ngClass]="{'bmc-topbar--search-mode': isSearchMode}">
      <bzg-input [(ngModel)]="searchText" (keyup)="onKeyUp()" (focus)="setSearchMode(true)"
        class="bz-space--inline-m" [autocomplete]="'off'"
        [placeholder]="'PACKAGE_VISUALIZER.PLACEHOLDER_SEARCH' | translate" actionIcnPosition="left">
        <bzg-icon nameIcon="icon-search"></bzg-icon>
      </bzg-input>
    </div>
  </div>
</div>